import { HttpService } from '@/data/http/http-service';
import { References } from '@/domain/impact-references/entities/references.entity';
import { ImpactReferencesGateway } from '@/domain/impact-references/gateways/impact-references.gateway';

import { referencesDtoSchema } from './references.dto.schema';
import { ReferencesMapper } from './references.mapper';

export class ApiImpactReferencesHttpGateway implements ImpactReferencesGateway {
  private http = new HttpService({
    baseURL: import.meta.env.VITE_API_IMPACT,
  });

  async getReferences(projectId: number): Promise<References> {
    const url = `/references?projectId=${projectId}`;
    const response = await this.http.get(url);
    const result = referencesDtoSchema.safeParse(response.data);
    if (result.success === false) {
      console.error(result.error);
      throw result.error;
    }
    const references = ReferencesMapper.dtoToEntity(result.data);
    return references;
  }
}
